import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { DatePipe } from "@angular/common";
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';


import { MatSelect } from "@angular/material/select";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import {
  DatoPaginadoModel,
  Paging,
} from "src/app/shared/models/dato-paginado.model";
import { ModalConfirmarRespuestaComponent } from "src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component";
import {
  ConfirmarRespuestaModel,
  ConfirmarRespuestaType,
} from "src/app/shared/models/confirmar-respuesta.model";
import { CategoriaService } from "./categoria.service";


@Component({
  selector: "app-categoria",
  templateUrl: "./categoria.component.html",
  styleUrls: ["./categoria.component.scss"],
})
export class CategoriaComponent implements OnInit, OnDestroy {
  @ViewChild('allSelected') allSelected: MatSelect;

  dataTabla: DatoPaginadoModel;
  headerCategoria: Array<string>;
  formCategoria: FormGroup;
  selectCategoria: any;
  paginaActual: number;
  // filtros
  filtro: FormGroup;
  public isCollapsed = true;
  opcionesSubcategoria = [
    { name: "Ninguno", value: "0" },
    { name: "Actualización", value: "1" },
    { name: "Renovación (Reactivacion+Renovacion)", value: "2" },
    { name: "Actualización y Renovación (Reactivacion+Renovacion)", value: "3" },
  ];
  listadoCategorias: any[] = [];
  isOnPermitirCambioCategoria: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private categoriaService: CategoriaService,
    private modalService: NgbModal,
    public datepipe: DatePipe
  ) {
    this.dataTabla = {
      paging: {} as Paging,
    } as DatoPaginadoModel;

    this.createForm();
    this.selectCategoria = null;
    this.paginaActual = 1;
  }

  ngOnInit() {
    this.headerCategoria = [
      "Descripción",
      "Cambio en el formulario de",
      "Estado",
      "Acción",
    ];
    this.onConsultarCategoria(1);
    this.onLoadListaCategorias();

  }

  ngOnDestroy(): void {
    this.isOnPermitirCambioCategoria = false;
    this.listadoCategorias = [];
  }

  createForm() {
    this.formCategoria = this.formBuilder.group({
      descripcion: [null, Validators.required],
      activo: [true],
      tipo_permiso: ["0", Validators.required],
      permite_cambio_categoria: [false],
      obligatorio_actualizacion: [false],
      obligatorio_renovacion: [false],
      listado_categoria: [new Array()],
      fecha_inicio_cambio_categoria: [null],
      fecha_fin_cambio_categoria: [null],
      mensaje_permitir_cambio_categoria: [""],
      titulo_mensaje_permitir_cambio_categoria: [""],
      checkAll: [false]
    });

    this.filtro = this.formBuilder.group({
      descripcion: [null],
      activo: [null],
      tipo_permiso: [null],
    });
  }

  onConsultarCategoria(page: number) {
    this.categoriaService
      .get({ ...this.filtro.value, numeroPagina: page })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.dataTabla = resultado.data as DatoPaginadoModel;
        }
      });
  }

  onPaginado(value: number) {
    this.paginaActual = value;
    this.onConsultarCategoria(value);
  }

  onAgregarCategoria() {
    const permiteCambiosCategoria = this.onPermitirCambiosCategoriaTrue();
    let listado_categoria =this.formCategoria.get('listado_categoria').value.filter(cat => cat.categoria_id != 0);
    if (permiteCambiosCategoria) {
      this.categoriaService
        .create({
          ...this.formCategoria.value,
          listado_categoria,
          activo: 1,
        })
        .subscribe((resultado) => {
          if (resultado.result) {
            this.onConsultarCategoria(this.paginaActual);
            this.limpiarCategoria();
          }
        });
    }
  }

  onOperarCategoria() {
    if (!this.selectCategoria) {
      this.onAgregarCategoria();
    } else {
      this.onModificarCategoria();
    }
  }

  onCargarCategoria(item: any) {
    this.categoriaService.getById(item.categoria_id).subscribe((x: any) => {
      let arr = [];
      x.data.listado_categoria.forEach((item: any) => {
        arr.push(item.categoria_id);
      });
      const data = {
        ...x.data,
        activo: item.activo ? 1 : 0,
        listado_categoria: arr,
        fecha_inicio_cambio_categoria: x.data.fecha_inicio_cambio_categoria ? this.datepipe.transform(
          x.data.fecha_inicio_cambio_categoria,
          "yyyy-MM-dd"
        ) : null,
        fecha_fin_cambio_categoria: x.data.fecha_fin_cambio_categoria ? this.datepipe.transform(
          x.data.fecha_fin_cambio_categoria,
          "yyyy-MM-dd"
        ): null,
      };
      this.formCategoria.patchValue(data);
      this.onChangePermitirCambioCategoria();
      this.selectCategoria = item;
    });
  }

  onEliminarCategoria(entry: any) {
    const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, {
      centered: true,
    });
    const confirmarRespuesta = {} as ConfirmarRespuestaModel;
    confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
    confirmarRespuesta.message = `¿Está seguro de eliminar la configuración seleccionada?`;
    modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
    modalRef.result.then(() => {
      this.categoriaService.delete(entry).subscribe((resultado) => {
        if (resultado.result) {
          // tslint:disable-next-line:max-line-length
          const index = this.dataTabla.items
            .map(function (e) {
              return e.categoria_id;
            })
            .indexOf(entry.categoria_id);
          this.dataTabla.items.splice(index, 1);
          this.selectCategoria = null;
          this.formCategoria.reset();
        }
      });
    });
  }

  toggleAllSelection() {
    if (this.allSelected.selected) {
      console.log(this.listadoCategorias.map(item => item.categoria_id));
		  this.formCategoria.controls.listado_categoria
			    .patchValue([...this.listadoCategorias.map(item => item.categoria_id), 0]);
		} else {
		  this.formCategoria.controls.listado_categoria.patchValue([]);
		}
  }

  onModificarCategoria() {
    const permiteCambiosCategoria = this.onPermitirCambiosCategoriaTrue();
    if (permiteCambiosCategoria) {
      this.categoriaService
        .update({
          ...this.formCategoria.value,
          categoria_id: this.selectCategoria.categoria_id,
        })
        .subscribe((resultado) => {
          if (resultado.result) {
            this.onConsultarCategoria(this.paginaActual);
            this.formCategoria.reset();
            this.selectCategoria = null;
          }
        });
    }
  }

  onPermitirCambiosCategoriaTrue(): boolean {
    if (
      this.formCategoria.controls.listado_categoria.value.length > 0 &&
      !this.formCategoria.controls.listado_categoria.value[0].categoria_id
    ) {
      let arr = [];
      this.formCategoria.controls.listado_categoria.value.forEach(
        (item: number) => {
          arr.push({ categoria_id: item });
        }
      );
      this.formCategoria.controls.listado_categoria.setValue(arr);

      return true;
    }

    return true;
  }

  filtrar() {
    this.paginaActual = 1;
    this.onConsultarCategoria(1);
  }

  limpiar() {
    this.filtro.reset();
    this.filtrar();
  }

  limpiarCategoria() {
    this.formCategoria.reset();
    this.selectCategoria = null;
    this.createForm();
    this.onChangePermitirCambioCategoria();
  }

  nombreOpcionesSubcategoria(valor) {
    return this.opcionesSubcategoria
      .filter((op) => op.value == valor)
      .map((opcion) => opcion.name);
  }

  onChangePermitirCambioCategoria(): any {
    const form = this.formCategoria.controls;
    if (!form.permite_cambio_categoria.value) {
      form.fecha_inicio_cambio_categoria.clearValidators();
      form.fecha_fin_cambio_categoria.clearValidators();
      form.mensaje_permitir_cambio_categoria.clearValidators();
      form.titulo_mensaje_permitir_cambio_categoria.clearValidators();
      return (
        (this.isOnPermitirCambioCategoria = false),
        form.obligatorio_actualizacion.setValue(false),
        form.obligatorio_renovacion.setValue(false),
        form.listado_categoria.setValue([]),
        form.fecha_inicio_cambio_categoria.setValue(null),
        form.fecha_fin_cambio_categoria.setValue(null),
        form.mensaje_permitir_cambio_categoria.setValue("")
      );
    }else{
      form.fecha_inicio_cambio_categoria.setValidators(Validators.required);
      form.fecha_fin_cambio_categoria.setValidators(Validators.required);
      form.mensaje_permitir_cambio_categoria.setValidators(Validators.required);
      form.titulo_mensaje_permitir_cambio_categoria.setValidators(Validators.required);
    }
    form.fecha_inicio_cambio_categoria.updateValueAndValidity();
    form.fecha_fin_cambio_categoria.updateValueAndValidity();
    form.mensaje_permitir_cambio_categoria.updateValueAndValidity();
    form.titulo_mensaje_permitir_cambio_categoria.updateValueAndValidity();

    return (this.isOnPermitirCambioCategoria = true);
  }

  onLoadListaCategorias(): any {
    this.categoriaService.getAllCategorias().subscribe((x: any) => {
      this.listadoCategorias = x.data;
    });
  }
  get fecha_inicio_cambio_categoria(){
    return this.formCategoria.get('fecha_inicio_cambio_categoria');
  }
  get fecha_fin_cambio_categoria(){
    return this.formCategoria.get('fecha_fin_cambio_categoria');
  }
  get mensaje_permitir_cambio_categoria(){
    return this.formCategoria.get('mensaje_permitir_cambio_categoria');
  }
  get titulo_mensaje_permitir_cambio_categoria(){
    return this.formCategoria.get('titulo_mensaje_permitir_cambio_categoria');
  }
  get requiredMessage(): string{
    return "Este campo es requerido";
  }
}
